import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import Media from "components/ui/media"

import { faqData } from "./data"

const FAQCarousel = () => {
  return (
    <Media className="mx-16 mb-48" lessThan="tablet">
      <Carousel aria-label="Warranty FAQ">
        <CarouselContent>
          {faqData().map((faq, ix) => (
            <CarouselItem
              className="px-48 text-center"
              key={`${faq.name}-${ix}`}
            >
              <h2 className="text-16 pb-16">{faq.title}</h2>
              <p>{faq.text}</p>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="inline-flex" />
        <CarouselNext className="inline-flex" />
      </Carousel>
    </Media>
  )
}

export default FAQCarousel
